<script lang="ts" setup>
  withDefaults(defineProps<{ icon: string; color?: string; size?: string }>(), {
    color: 'var(--color-base-black)',
    size: '24px'
  })
</script>

<template>
  <ion-icon :icon="icon" />
</template>

<style lang="scss" scoped>
  ion-icon {
    font-size: v-bind('size');
    color: v-bind('color');
    flex: 0 0 auto;
  }
</style>
